<template>
  <v-container>
    <template v-if="perfil !== 'Validación'">
      <v-row>
        <v-col cols="12">
          <div class="text-subtitle-1 font-weight-bold d-inline">
            Vehículos
          </div>
          <agregar-vehiculo-dialog-component :id-personal="personal.idPersonal" />
        </v-col>
      </v-row>
      <v-row v-if="vehiculos.length > 0">
        <v-col
          v-for="vehiculo in vehiculos"
          :key="vehiculo.idVehiculo"
          cols="3"
        >
          <v-card
            color="secondary"
            tile
          >
            <v-card-title class="d-inline-block">
              <div class="text-subtitle-1 font-weight-bold white--text">
                Modelo {{ vehiculo.catModelo.nombre }}
              </div>
              <div class="text-subtitle-2 font-weight-bold white--text">
                Placas: {{ vehiculo.placa }}
              </div>
              <div class="text-body-2 primary--text">
                Adquirido el {{ vehiculo.fechaAdquisicion }}
              </div>
            </v-card-title>
            <v-card-actions class="justify-center">
              <VehiculoDialog
                :id="idExpediente"
                :update-data="vehiculo"
              />
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col
          cols="12"
          align="center"
        >
          <div class="text-subtitle-1 font-weight-bold text--disabled">
            No hay vehículos registrados.
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="text-subtitle-1 font-weight-bold d-inline">
            Sanciones administrativas
          </div>
          <agregar-sancion-dialog-component :id-personal="personal.idPersonal" />
        </v-col>
      </v-row>
      <v-row v-if="sanciones.length > 0">
        <v-col
          v-for="(sancion, index) in sanciones"
          :key="index"
          cols="3"
        >
          <v-card
            color="secondary"
            tile
          >
            <v-card-title class="d-inline-block">
              <div class="text-subtitle-1 font-weight-bold white--text">
                Motivo {{ sancion.motivo }}
              </div>
              <div class="text-subtitle-2 font-weight-bold white--text">
                Folio: {{ sancion.folio }}
              </div>
              <div class="text-body-2 primary--text">
                Sancionado el {{ sancion.fechaSancion }}
              </div>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col
          cols="12"
          align="center"
        >
          <div class="text-subtitle-1 font-weight-bold text--disabled">
            No hay sanciones registradas.
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="text-subtitle-1 font-weight-bold d-inline">
            Situación financiera
          </div>
          <agregar-situacion-financiera-dialog-component :id-expediente="idExpediente" />
        </v-col>
      </v-row>
      <v-row v-if="situaciones.length > 0">
        <v-col
          v-for="situacion in situaciones"
          :key="situacion.idSituacionFinanciera"
          cols="3"
        >
          <v-card
            color="secondary"
            tile
          >
            <v-card-title class="d-inline-block">
              <div class="text-subtitle-1 font-weight-bold white--text">
                Ingresos: {{ situacion.CatIngreso.title }}
              </div>
              <div class="text-body-2 primary--text">
                Dependientes económicos: {{ situacion.dependientesEconomicos }}
              </div>
            </v-card-title>
            <v-card-text>
              <div class="text-caption primary--text">
                Servicios:
              </div>
              <v-list
                dense
                color="primary"
              >
                <v-list-item
                  v-for="(servicio, index) in situacion.servicios"
                  :key="index"
                >
                  <v-list-item-title>{{ servicio.CatServicios.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col
          cols="12"
          align="center"
        >
          <div class="text-subtitle-1 font-weight-bold text--disabled">
            No hay situaciones financieras registradas.
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="text-subtitle-1 font-weight-bold d-inline">
            Datos laborales
          </div>
          <agregar-datos-laborales-dialog-component :id-expediente="idExpediente" />
        </v-col>
      </v-row>
      <v-row v-if="datosLaborales.length > 0">
        <v-col
          v-for="datoLaboral in datosLaborales"
          :key="datoLaboral.id"
          cols="3"
        >
          <v-card
            color="secondary"
            tile
          >
            <v-card-title class="d-inline-block">
              <div class="text-subtitle-1 font-weight-bold white--text">
                {{ datoLaboral.empresa }}
              </div>
              <div class="text-subtitle-2 font-weight-bold white--text">
                {{ datoLaboral.puesto }}
              </div>
              <div class="text-body-2 primary--text">
                {{ datoLaboral.periodo }}
              </div>
            </v-card-title>
            <v-card-text>
              <div class="text-caption primary--text">
                Motivo de salida
              </div>
              <div class="text-body-2 font-weight-bold primary--text">
                {{ datoLaboral.motivoConclusion }}
              </div>
            </v-card-text>
            <v-card-actions class="justify-center">
              <DatoLaboralDialog
                :id="idExpediente"
                :update-data="datoLaboral"
              />
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col
          cols="12"
          align="center"
        >
          <div class="text-subtitle-1 font-weight-bold text--disabled">
            No hay datos laborales registradas.
          </div>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row>
        <v-col>
          <v-alert
            border="left"
            color="secondary"
            class="white--text"
          >
            No tiene permisos para ver esta información.
          </v-alert>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>
<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import AgregarVehiculoDialogComponent from './AgregarVehiculoDialogComponent.vue';
import AgregarSancionDialogComponent from './AgregarSancionDialogComponent.vue';
import AgregarSituacionFinancieraDialogComponent from './AgregarSituacionFinancieraDialogComponent.vue';
import AgregarDatosLaboralesDialogComponent from './AgregarDatosLaboralesDialogComponent.vue';
import VehiculoDialog from '../VehiculoDialog.vue';
import DatoLaboralDialog from '../DatoLaboralDialog.vue';

export default {
  components: {
    AgregarVehiculoDialogComponent,
    AgregarSancionDialogComponent,
    AgregarSituacionFinancieraDialogComponent,
    AgregarDatosLaboralesDialogComponent,
    VehiculoDialog,
    DatoLaboralDialog,
  },

  props: {
    personal: {
      type: Object,
      default: () => null,
    },

    idExpediente: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    ...mapGetters('vehiculos', {
      vehiculos: 'getVehiculos',
    }),

    ...mapGetters('sancionesAdministrativas', {
      sanciones: 'getSancionesAdministrativas',
    }),

    ...mapGetters('situacionFinanciera', {
      situaciones: 'getSituacionFinanciera',
    }),

    ...mapGetters('datosLaborales', {
      datosLaborales: 'getDatosLaborales',
    }),
  },

  methods: {
    formatDate(fecha) {
      return moment(fecha).format('DD/MM/YYYY');
    },
  },
};
</script>
